import React, { useContext, useState } from 'react';
import { SettingsBannerContext } from '../../../contexts/SettingsBannerContext';
import { MasterBannerContext } from '../../../contexts/MasterBannerContext';
import Element from './Element';
import './index.css';

function Elements() {
  const { layerActive } = useContext(SettingsBannerContext);
  const { master } = useContext(MasterBannerContext);
  const [ group, setGroup ] = useState(null);

  function OpenGroup(item) {
    if (item === group) {
      setGroup("");
    } else setGroup(item);
  }

  function activeFilter (id, arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].element.id === id.name && arr.length <= 1 )  {
        return  true;
      }
      else if(arr[i].element.id === id.name && arr[i].type === id.type.toLowerCase()){
        return true;
      }
    }
    return false;
  }

  return (
      <div style={{ height: '100%', padding: '0px 20px', margin: 'auto', width: '1200px'}}>
      <div style={{display: 'flex', height: '20px', margin: '0px 0px 5px 0px', justifyContent: 'space-around'}}>
          <div style={{minWidth: '170px', fontWeight: 'bold', textAlign: 'center', fontSize: '14px'}}>
            Camadas
          </div>
          <div style={{minWidth: '100px', fontWeight: 'bold', textAlign: 'center', fontSize: '14px'}}>
            Delay
          </div>
          <div style={{minWidth: '100px', fontWeight: 'bold', textAlign: 'center', fontSize: '14px'}}>
            Tipo
          </div>
          <div style={{minWidth: '150px', fontWeight: 'bold', textAlign: 'center', fontSize: '14px'}}>
            Animação
          </div>
          <div style={{minWidth: '100px', fontWeight: 'bold', textAlign: 'center', fontSize: '14px'}}>
            Duração
          </div>
          <div style={{minWidth: '100px', fontWeight: 'bold', textAlign: 'center', fontSize: '14px'}}>
            Direção
          </div>
        </div>
        {master.preset ? master.preset.map((item, index) =>
        <div style={{
          border: item.children && group === item.name && item.type.toLowerCase() === "in" ?
           '3px solid rgb(99, 186, 230)' : item.parent ?
            'none' : '3px solid transparent', 
          background: item.children && group === item.name && item.type.toLowerCase() === "in" ?
           'antiquewhite' : 'none',
           borderRadius: '10px',
           paddingBottom: item.children && group === item.name && item.type.toLowerCase() === "in" ? '6px' : '0px',
           cursor: 'pointer'
          }} 
          key={Math.random()}>
            {!item.parent ?
              <Element
                item={item}
                active={activeFilter(item, layerActive)}
                openGroup={(evt) => OpenGroup(evt)}
                group={group !== item.name}
              />
                :
              <></>
            }
            {item.children && group === item.name && item.type.toLowerCase() === "in" ?
              master.preset.map(children =>
                children.parent === item.name ?
                <Element
                  item={children}
                  active={activeFilter(children, layerActive)}
                  group={false}
                />
                : <></>
              )
            : <></>}
          </div>
      ) : <></>}
      </div>
  )
}

export default Elements;